import { useRef, useState } from "react";
import { toast } from "sonner";
import api, { apiFetchBlobUrl } from "../../lib/api";
import { segnaUsato } from "../../lib/aiUpload";
import { FilePdf, CircleNotch } from "@phosphor-icons/react";

export async function caricaAllegato(movimentoId, file) {
  const fd = new FormData(); fd.append("file", file);
  const r = await api.post(`/impresa/movimenti/${movimentoId}/allegato`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  segnaUsato(file);
  return r;
}

export default function AllegatoBtn({ m, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const apri = async () => { try { const u = await apiFetchBlobUrl(`/impresa/movimenti/${m.id}/allegato`, m.allegato_tipo || "application/pdf"); window.open(u, "_blank", "noopener"); } catch { toast.error("Allegato non disponibile"); } };
  const upload = async (f) => { if (!f) return; setBusy(true); try { await caricaAllegato(m.id, f); toast.success("Allegato salvato"); onChange?.(); } catch { toast.error("Upload non riuscito"); } finally { setBusy(false); } };
  const rimuovi = async (e) => { e.preventDefault(); if (!m.allegato_path || !window.confirm("Rimuovere l'allegato?")) return; await api.delete(`/impresa/movimenti/${m.id}/allegato`); onChange?.(); };
  return (
    <>
      <input ref={ref} type="file" accept=".pdf,image/*" className="hidden" onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid={`allegato-file-${m.id}`} />
      <button type="button" onClick={() => (m.allegato_path ? apri() : ref.current?.click())} onContextMenu={rimuovi} title={m.allegato_path ? `${m.allegato_nome || "Allegato"} · click per aprire · tasto destro per rimuovere` : "Allega PDF / foto del documento"} className="h-7 w-7 inline-flex items-center justify-center rounded hover:bg-slate-100" data-testid={`allegato-${m.id}`}>
        {busy ? <CircleNotch size={15} className="animate-spin text-slate-400" /> : <FilePdf size={16} weight={m.allegato_path ? "fill" : "regular"} className={m.allegato_path ? "text-red-600" : "text-slate-300"} />}
      </button>
    </>
  );
}
